// download all document
const downloadAllDocRL = state => state.downloadAllDocRL.data
const errorDownloadAllDocRL = state => state.errorDownloadAllDocRL
const isLoadingDownloadAllDocRL = state => state.isLoadingDownloadAllDocRL

export default {
  downloadAllDocRL,
  errorDownloadAllDocRL,
  isLoadingDownloadAllDocRL
}



// WEBPACK FOOTER //
// ./src/store/modules/requestlist/getters.js